module.exports = __webpack_public_path__ + "s/img/Play_D_3.5bd6bd3a.jpg";